export const getCookieValue = function(name) {
    var value = '; ' + document.cookie,
        parts = value.split('; ' + name + '=');
    return parts.length > 1 ? parts.pop().split(';').shift() : false;
};

const getExpiryDate = function() {
  // 1 year (365*24*60*60*1000 ms)
  return (new Date((new Date()).getTime() + (365 * 24 * 60 * 60 * 1000))).toUTCString();
};

export const setReferrerCookie = function(referrer) {
    if (referrer === getCookieValue('huReferrer')) {
        return;
    }
    document.cookie = 'huReferrer=' + referrer + '; path=/; expires=' + getExpiryDate();
};

export const getBranch = function() {
    const huBv = getCookieValue('huBv');
    return !!huBv ? huBv.charAt(0).toUpperCase() : 'A';
};

export const getUserType = function() {
    const huBv = getCookieValue('huBv');
    const userInt = !!huBv ? parseInt(huBv.charAt(1)) : 0;
    const userType = userInt === 0 ? 'Visitor' : 'Member';
    return userType;
};

export const getLangCookie = () => getCookieValue('huLang');

export const setLangCookie = function(lang) {
    // Set cookie to expire in 1 year (365*24*60*60*1000 ms)
    const expires = (new Date((new Date()).getTime() + (365 * 24 * 60 * 60 * 1000))).toUTCString();

    document.cookie = 'huLang=' + lang + '; path=/; expires=' + expires;
};



// WEBPACK FOOTER //
// ./src/utils/cookie.js